import ForgotPasswordForm from 'src/components/ForgotPasswordForm';

const ForgotPassword = () => <ForgotPasswordForm />;
export default ForgotPassword;
